import React, { useEffect, useState } from 'react';
import axios from 'axios';
import qs from 'qs';
import Access from "../../Components/Access";
import Navbar from "../../Components/Navbar";
import {NotificationManager} from 'react-notifications';
import Nn1n2 from "../../Components/Nn1n2";


const Annee_FCTVA = (props) =>
{
    const [dialogModalVisible, setDialogModalVisible] = useState(false);
    const [budget, setBudget] = useState(null);
    const [taux, settaux] = useState(null);
    
    const purple = '#6571FE';

    async function mount()
    {
        // Récupération du budget de l'utilisateur
        const params = {
            'getBudgets': true,
            'id': props.user.id_budget
        }
        await axios.post('https://app-slfinance.fr/api/budgets.php', qs.stringify(params))
        .then(async (res) => {
            await setBudget(res.data[0])
        })
        .catch((err) => {
            console.warn(err)
        })
    }

    useEffect(() => {
        if (props.user === null) {
            props.getUser();
        } else {
            mount();
        }
    }, [props.user]);

    return (
        <div>
            <Access needConnection={true} type_user={[0,1,2]}>
                <Navbar user={props.user} />

                <div style={{display: 'flex', margin: 25}}>
                    <p>Paramètre \</p>
                    <p style={{color: purple, marginLeft: 5, fontWeight: 'bold'}}>Année de référence et taux du FCTVA</p>
                </div>

                {props.user &&
                <div style={{flex: 1, margin: 10}}>
                    <Nn1n2 budget={budget} user={props.user} />
                </div>
                }

            </Access>
        </div>
    );
}

export default Annee_FCTVA;
